function googleTagManagerIsNotBlocked() {
    return window.google_tag_manager
}

function googleTagManagerIsBlocked() {
    return !googleTagManagerIsNotBlocked()
}

var googleTagManagerPushEventToDataLayer = function (eventData, callback) {
    if (googleTagManagerIsBlocked()) {
        if (callback) {
            return callback()
        }

        return true
    }

    window.dataLayer.push({
        ...eventData,
        eventCallback: callback ? callback() : () => {},
    })
}

export default googleTagManagerPushEventToDataLayer


// WEBPACK FOOTER //
// ./application/assets/js/site/helpers/gtm.js